const IAT_CARRIER_GROUP_IDS = ["IAT", "SIC"];

export default IAT_CARRIER_GROUP_IDS;
